import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { TariffCompared } from "./tariffCompared"
import { ITariffCompared } from "./tariffCompared.types"
import {
  ITariffDetailsRaw,
  TariffDetailsParser,
} from "../tariffDetails/tariffDetails.parser"
import { TariffMonthlyRateResponse } from "@/api/backofficeRest/generated/model"

export interface ITariffComparedRaw {
  next_month_gas?: ITariffDetailsRaw
  this_month_gas?: ITariffDetailsRaw
  next_month_electricity?: ITariffDetailsRaw
  this_month_electricity?: ITariffDetailsRaw
}

export const TariffComparedParser: IParser<
  ITariffCompared,
  ITariffComparedRaw
> = {
  toDomain: (data: ITariffComparedRaw) => {
    try {
      const thisMonthRaw = data.this_month_gas || data.this_month_electricity
      const nextMonthRaw = data.next_month_gas || data.next_month_electricity

      const thisMonth = thisMonthRaw
        ? TariffDetailsParser.toDomain(thisMonthRaw)
        : undefined

      const nextMonth = nextMonthRaw
        ? TariffDetailsParser.toDomain(nextMonthRaw)
        : undefined

      return new TariffCompared(thisMonth, nextMonth)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const parseTariffMonthlyRateResponse = (
  data: TariffMonthlyRateResponse,
): ITariffCompared => {
  const parseMonth = (
    month?: TariffMonthlyRateResponse["thisMonth"],
  ): ITariffDetailsRaw | undefined => {
    if (!month) return undefined
    return {
      code: month.code,
      gsp_group: month.gspGroup,
      display_name: month.displayName,
      standing_charge: month.standingCharge,
      early_termination_charge: month.earlyTerminationCharge,
      unit_rate: month.unitRate ?? undefined,
      day_rate: month.dayRate ?? undefined,
      night_rate: month.nightRate ?? undefined,
    }
  }

  const mapIfDefined = (raw?: ITariffDetailsRaw) =>
    raw ? TariffDetailsParser.toDomain(raw) : undefined

  return new TariffCompared(
    mapIfDefined(parseMonth(data.thisMonth)),
    mapIfDefined(parseMonth(data.nextMonth)),
  )
}
